import { Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import { invoiceTypes } from "astrid-firestore/src/api/invoices/invoiceTypes";

import CreateSalesOrderInvoice from "../../../../invoices/components/CreateSalesOrderInvoice";
import Table from "../../../../tables/components/Table";

import useInvoicesColumns from "../hooks/useInvoicesTableColumns";

function shouldShowCreateInvoice({ order, invoices }) {
	const latestInvoice = invoices?.[0];

	return !order.processed && !order.inactivated && (!invoices?.length || latestInvoice?.type === invoiceTypes.CREDIT);
}

export default function OrderInvoices({ order, invoices }) {
	const { t } = useTranslation();
	const columns = useInvoicesColumns();

	return (
		<>
			<Header as="h3">{t("invoiceHeader", "Invoices")}</Header>

			{shouldShowCreateInvoice({ order, invoices }) && (
				<CreateSalesOrderInvoice order={order} invoices={invoices} />
			)}

			<Table columns={columns} data={invoices} />
		</>
	);
}
